(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractBookedController', ContractBookedController);

    ContractBookedController.$inject = ['$scope', 'ContractCustomService', 'XLSXExportService', 'ToastrService', 'MiscService', 'DateUtils'];

    function ContractBookedController($scope, ContractCustomService, XLSXExportService, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.downloadReport = downloadReport;
        vm.openCalendar = openCalendar;
        vm.refresh = refresh;
        vm.onStartDateChange = onStartDateChange;
        vm.lastDayOfMonth = lastDayOfMonth;
        vm.resetForm = resetForm;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        resetForm();

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAll() {
            vm.bookedContractsList = [];
            vm.statusText = "Fetching Booked Contracts";
            ContractCustomService.returnBookedContracts(DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate), vm.contractType, vm.contractStatus).then(function( result ) {
                vm.bookedContractsList = result.data;
                generateStatusText();
                if( vm.bookedContractsList.length < 1 ) {
                    vm.statusText = "Nothing fetched for Booked Contracts with given date range";
                    ToastrService.info(vm.statusText, "Info");
                }
            }, function( error ) {
                if(error.status !== "404") {
                    ToastrService.error("Failed to fetch Booked Contracts", "Error");
                }
                vm.statusText = "Failed to fetch Booked Contracts";
            });
        }

        function downloadReport() {
            if(vm.bookedContractsList.length > 0) {
                XLSXExportService.downloadBookedContractsReport(DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate), vm.contractType, vm.contractStatus).then( function( data, status, headers, config ) {
                    var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    saveAs(file, "BookedContracts.xls");
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Failed to download Booked Contracts Report", "Error");
                    }
                });
            } else {
                ToastrService.info("Nothing to download", "Info");
            }
        }

        function refresh() {
            loadAll();
        }

        function resetForm() {
            vm.bookedContractsList = [];
            vm.startDate = MiscService.generateStartDate( new Date() );
            vm.endDate = MiscService.generateEndDate( new Date() );
            vm.statusText = "Waiting for Command...";
            vm.contractType = {purchase:true, sale:true};
            vm.contractStatus = {draft:true, issued:true, complete:true, signed:true, cancelled:false};
        }

        function onStartDateChange() {
            vm.endDate = MiscService.onStartDateChange( vm.startDate, vm.endDate );
        }

        function lastDayOfMonth() {
            vm.endDate = MiscService.generateLastDayOfMonth( vm.endDate );
        }

        function generateStatusText() {
            if( vm.startDate.getTime() === vm.endDate.getTime() ) {
                vm.statusText = "Showing " + vm.bookedContractsList.length + " Booked Contracts for " + vm.startDate.toLocaleDateString("en-US");
            } else {
                vm.statusText = "Showing " + vm.bookedContractsList.length + " Booked Contracts from " + vm.startDate.toLocaleDateString("en-US") + " to " + vm.endDate.toLocaleDateString("en-US");
            }
        }
    }
})();
